import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, renderSlot as _renderSlot, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60ad3f31"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tour" }
const _hoisted_2 = { class: "tour__title" }
const _hoisted_3 = { class: "tour__text" }
const _hoisted_4 = { class: "tour__content" }
const _hoisted_5 = ["data-visible"]

import { Ref, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseTour',
  props: {
    title: {},
    text: {},
    steps: {}
  },
  emits: ["close"],
  setup(__props: any) {




const currentStep: Ref<number> = ref(1);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.text), 1),
    (typeof _ctx.steps !== 'number')
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "tour__button button button-light button-md",
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, " Понял "))
      : (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "tour__button button button-light button-md",
          type: "button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (currentStep.value !== _ctx.steps ? currentStep.value++ : _ctx.$emit('close')))
        }, [
          (currentStep.value !== _ctx.steps)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode("Далее")
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode("Понял")
              ], 64))
        ])),
    _createElementVNode("div", _hoisted_4, [
      (typeof _ctx.steps !== 'number')
        ? _renderSlot(_ctx.$slots, "default", { key: 0 })
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.steps, (index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "tour__step-container",
              "data-visible": currentStep.value === index
            }, [
              _renderSlot(_ctx.$slots, `step-${index}`)
            ], 8, _hoisted_5))
          }), 128))
    ])
  ]))
}
}

})